import { Skeleton, Box } from '@mui/material';
import ElementTitle from '../../../../components/title/elementTitle/elementTitle';

const ChequesListSkeleton = () => {
    return (
        <div>
            {/* <ElementTitle title="چک‌های ضمانت" /> */}
            {[...Array(1)].map((_, index) => (
                <Box key={index} sx={{ marginBottom: '16px' }}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="80%" height={20} />
                </Box>
            ))}
            <ElementTitle title="چک‌های اقساط" />
            {[...Array(3)].map((_, index) => (
                <Box key={index} sx={{ marginBottom: '16px' }}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="80%" height={20} />
                </Box>
            ))}
        </div>
    );
};

export default ChequesListSkeleton;
